import * as React from "react";
import type { SVGProps } from "react";
const SvgShareIos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#share-ios_svg__a)">
      <path d="M19 22H5c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1H6v11h12V9h-1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1v13c0 .55-.45 1-1 1" />
      <path d="M12 15c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1" />
      <path d="M15 6c-.19 0-.38-.05-.55-.17l-3-2a1.01 1.01 0 0 1-.28-1.39c.31-.46.92-.58 1.39-.28l3 2c.46.31.58.93.28 1.39-.19.29-.51.45-.83.45z" />
      <path d="M9 6c-.32 0-.64-.16-.83-.45-.31-.46-.18-1.08.28-1.39l3-1.99a1.001 1.001 0 1 1 1.11 1.67l-3 2c-.17.11-.36.17-.55.17z" />
    </g>
    <defs>
      <clipPath id="share-ios_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShareIos;
